import React, { useState, useEffect } from 'react';
import { Box, List, ListItem, ListItemText, Typography, Link } from '@mui/material';
// import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { getEventTickets } from 'actions/events';

const classes = {
  root: {
    flexGrow: 1,
    maxWidth: 752,
  },
  sourceImage: {
    width: '100%',
    height: 'auto',
    maxWidth: 200,
  },
  imageContainer: (theme) => ({
    width: '48%',
    marginLeft: theme.spacing(),
  }),
};

const EventTickets = ({ eventId, pricing = null }) => {
  const [tickets, setTickets] = useState(pricing);

  useEffect(() => {
    if (!tickets && eventId) {
      const getTickets = async () => {
        const tickets = await getEventTickets(eventId);
        setTickets(tickets);
      };
      getTickets();
    }
  }, [eventId, tickets]);

  if (!tickets) {
    return 'Loading';
  }

  const renderTicketPrice = (price, min, max) => {
    if (price) {
      return `£${price}`;
    }
    if (min && max) {
      return `£${min} - £${max}`; // TODO: Get currency from event
    }
  };

  const getTicketSourceImage = (source) => {
    switch (source) {
      case 'ticketmaster':
        return (
          <Box
            component="img"
            sx={classes.sourceImage}
            src="/srv/logos/ticketmaster.svg"
            alt="From Ticketmaster"
            width="264"
            height="51"
          />
        );
      case 'seetickets':
      case 'See Tickets':
        return (
          <Box
            component="img"
            sx={classes.sourceImage}
            src="/srv/logos/seetickets.png"
            alt="From See Tickets"
            width="264"
            height="51"
          />
        );
      default:
        return '';
    }
  };

  return (
    <Box sx={classes.root} data-test="tickets-list">
      <Typography variant="subtitle2" sx={{ my: 2 }}>
        The following links navigate away from ZIKI.FM. Affiliate links help support the website.
      </Typography>
      {tickets?.length ? (
        tickets.map((ticket) => (
          <List dense>
            <ListItem
              sx={classes.tickets}
              button
              component="a"
              href={ticket.link}
              data-ziki-id={`tickets-${ticket.source}`}
              data-ziki-price={ticket.price || ticket.min_price}
            >
              <ListItemText
                primary={ticket.type || ticket.source}
                secondary={renderTicketPrice(ticket.price, ticket.min_price, ticket.max_price)}
              />
              <Box sx={classes.imageContainer}>{getTicketSourceImage(ticket.source)}</Box>
            </ListItem>
          </List>
        ))
      ) : (
        <Box pt={1} pb={1}>
          <Typography>No direct ticket links available at this time.</Typography>
          <ul>
            {tickets.tourspage && (
              <li>
                <Link href={tickets.tourspage}>Tours Page ({tickets.tourspage})</Link>
              </li>
            )}
            {tickets.website && (
              <li>
                <Link href={tickets.website}>Website ({tickets.website})</Link>
              </li>
            )}
            {tickets.tmlink && (
              <li>
                {' '}
                <Link href={tickets.tmlink}>Ticketmaster Page</Link>
              </li>
            )}
          </ul>
        </Box>
      )}
    </Box>
  );
};

export default EventTickets;
